var map = {
  "./lean__debugging__quality_of_logs.mock.json": [
    "40561",
    "31050"
  ],
  "./lean__estimation_accuracy__estimation_accuracy.mock.json": [
    "85326",
    "40131"
  ],
  "./coverage__completeness_of_requirements__reliability_and_availability.mock.json": [
    "95325",
    "44174"
  ],
  "./lean__test_run__test_stability.mock.json": [
    "32462",
    "31715"
  ],
  "./reliability__reliability_and_availability__availability_measured_in_nines_e_g_99_9_uptime.mock.json": [
    "35342",
    "91555"
  ],
  "./coverage__user_xp__web_ui_services.mock.json": [
    "8848",
    "26633"
  ],
  "./alignment__process__test_definition.mock.json": [
    "67526",
    "53131"
  ],
  "./coverage__requirements__business.mock.json": [
    "87172",
    "47621"
  ],
  "./alignment__requirements__nfr.mock.json": [
    "70563",
    "62240"
  ],
  "./coverage__completeness_of_requirements__usability_and_accessibility.mock.json": [
    "31454",
    "81715"
  ],
  "./coverage__code__back_end_services.mock.json": [
    "85930",
    "58094"
  ],
  "./alignment__requirements__business.mock.json": [
    "1009",
    "8266"
  ],
  "./alignment__process__quality_gates.mock.json": [
    "23384",
    "34305"
  ],
  "./alignment__process__test_implementation.mock.json": [
    "51007",
    "11924"
  ],
  "./coverage__user_xp__mobile_apps.mock.json": [
    "24991",
    "78420"
  ],
  "./lean__test_run__test_run_duration.mock.json": [
    "12691",
    "28560"
  ],
  "./alignment__process__risk_management_failures.mock.json": [
    "67683",
    "76416"
  ],
  "./coverage__code__bff_services.mock.json": [
    "66060",
    "85501"
  ],
  "./reliability__bugs_criticality__bugs_criticality.mock.json": [
    "69808",
    "81865"
  ],
  "./lean__debugging__debug_efficiency.mock.json": [
    "87555",
    "35616"
  ],
  "./coverage__completeness_of_requirements__maintainability_and_operability.mock.json": [
    "93585",
    "25514"
  ],
  "./coverage__completeness_of_requirements__security_and_privacy.mock.json": [
    "38754",
    "25517"
  ],
  "./alignment__process__roles.mock.json": [
    "44957",
    "98574"
  ],
  "./coverage__code__web_ui_services.mock.json": [
    "85365",
    "39286"
  ],
  "./coverage__user_xp__devices_apps.mock.json": [
    "15418",
    "50887"
  ],
  "./alignment__framework__environment.mock.json": [
    "9284",
    "20101"
  ],
  "./coverage__completeness_of_requirements__business.mock.json": [
    "67727",
    "83620"
  ],
  "./alignment__requirements__swagger.mock.json": [
    "57429",
    "2198"
  ],
  "./coverage__code__devices_apps.mock.json": [
    "85965",
    "33662"
  ],
  "./lean__process__a_i_usage.mock.json": [
    "78356",
    "84501"
  ],
  "./coverage__requirements__nfr.mock.json": [
    "18032",
    "71497"
  ],
  "./alignment__transparency__test_runs_quality_dashboard.mock.json": [
    "50749",
    "25550"
  ],
  "./alignment__framework__test_run_duration.mock.json": [
    "274",
    "84719"
  ],
  "./coverage__code__mobile_apps.mock.json": [
    "70650",
    "98407"
  ],
  "./reliability__bugs_origin__bugs_origin_ratio.mock.json": [
    "30220",
    "48125"
  ],
  "./reliability__reliability_and_availability__uptime_measured_in_nines_e_g_99_9_uptime.mock.json": [
    "61463",
    "50364"
  ],
  "./coverage__completeness_of_requirements__performance_and_scalability.mock.json": [
    "41923",
    "97632"
  ],
  "./coverage__requirements__swagger.mock.json": [
    "55010",
    "87583"
  ],
  "./alignment__transparency__test_results_dashboard.mock.json": [
    "84395",
    "4696"
  ],
  "./alignment__framework__level_of_automation.mock.json": [
    "47015",
    "30124"
  ],
  "./lean__debugging__debug_tooling.mock.json": [
    "80978",
    "51375"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 82942;
module.exports = __rspack_async_context;
